<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">納入場所一括登録</span>
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!valid" @click="submit">{{
          $t("app.buttons.add")
        }}</v-btn>
        <v-btn @click="show = false">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form ref="form" v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <remote-autocomplete
                :rules="[(v) => !!v || `納入場所を入力してください。`]"
                label="納入場所"
                url="warehouses/sjl-kv"
                v-model="finallyWarehouseId"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs12>
              <date-picker
                :rules="[(v) => !!v || `納入予定日時間を入力してください。`]"
                label="納入予定日時間"
                v-model="forecastDeliveryDate"
              ></date-picker>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[
                  (v) =>
                    /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) ||
                    `4桁の数の有効時間を入力してください`,
                ]"
                label="時間"
                v-model="forecastDeliveryTime"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                clearable
                label="コメント"
                v-model="remark"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    show: false,
    finallyWarehouseId: null,
    forecastDeliveryDate: null,
    forecastDeliveryTime: null,
    remark: "",
    valid: false,
  }),
  methods: {
    submit() {
      var time = this.$insert(this.forecastDeliveryTime, 0, 2, ":");
      time = this.$insert(time, 0, 5, ":");
      time = time + "00";
      this.$emit("submit", {
        finallyWarehouseId: this.finallyWarehouseId,
        forecastDeliveryDate: this.forecastDeliveryDate,
        forecastDeliveryTime: time,
        remark: this.remark,
      });
      this.show = false;
      this.$emit("refresh");
    },
    popup() {
      this.show = true;
    },
  },
};
</script>
